import * as React from 'react';

export interface IAccorditionItemProps {
  title: string;
  open?: boolean;
  shouldUpdate?: boolean;
}
export interface IAccorditionItemState {
  open: boolean | null;
  forceOpen: boolean;

}

export default class AccordionItem extends React.Component<IAccorditionItemProps, IAccorditionItemState> {
  constructor(props: any) {
    super(props);

    this.state = {
      open: props.open === undefined ? false : props.open,
      forceOpen: false,
    };
  }

  componentWillReceiveProps(nextProps: any) {
    if (nextProps.open !== undefined && !!nextProps.shouldUpdate) {
      this.setState({
        open: nextProps.open || this.state.forceOpen,
      });
    }
  }

  onToggle = (e: any) => {
    e.preventDefault();
    this.setState({
      open: !this.state.open,
      forceOpen: !this.state.open,
    });
  }

  render() {
    const { open } = this.state;

    const className = `drop-item-link ${open ? ' active' : ''}`;
    return (
      <div className="drop-item">
        <span onClick={this.onToggle} className={className}>
          <i className="fa fa-caret-right" aria-hidden="true"></i>
          {this.props.title}
        </span>
        {open &&
          <div className="drop-item-box">
            {this.props.children}
          </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/SidePanel/common/AccordionItem.tsx